/**
 * This fn will return object with name of component like we use it in our codebase and potential props based on componentName
 */
export default componentName => {
	const dictionary = {
		// Basic ones
		text: {
			name: "j-base-input-text",
			props: {}
		},
		longText: {
			name: "j-base-input-long-text",
			props: {}
		},
		number: {
			name: "j-base-input-number",
			props: {}
		},
		date: {
			name: "j-base-date-picker-simple",
			props: {}
		},
		toggle: {
			name: "j-base-toggle",
			props: {}
		},
		select: {
			name: "j-base-select",
			props: {}
		},
		radios: {
			name: "j-base-radios",
			props: {}
		},

		// Special ones
		currency: {
			name: "core-select-currency",
			props: {}
		}
	}

	// If componentName is not in the dictionary, return empty object otherwise return component object
	return dictionary[componentName] ? dictionary[componentName] : {}
}
